export default __webpack_public_path__ + "static/media/yellowArrowDownFull.a1c92c15.svg";